import Logo from "./images/l1.png";
import { MdOutlineLocationOn, MdMailOutline } from "react-icons/md";
import { IoPhonePortraitOutline } from "react-icons/io5";
import { FaLinkedin } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 py-12 px-6">
      <div className="max-w-7xl mx-auto flex flex-col gap-10 lg:flex-row justify-between">
        
        {/* Brand & Social Section */}
        <div className="flex flex-col items-start lg:w-1/3 space-y-4">
          <div className="flex items-center space-x-4">
            <img src={Logo} alt="Logo" className="h-12 w-24 object-contain" />
            <div>
              <h2 className="text-xl sm:text-2xl font-bold">iNVORA TECHNOLOGY</h2>
              <p className="text-sm text-gray-400">PRIVATE LIMITED</p>
            </div>
          </div>
          <p className="text-sm text-gray-400">
            An integrated engineering company, formed in 2016 – {new Date().getFullYear()}.
          </p>
          <div className="flex space-x-4 pt-2">
           
            <a href="https://www.linkedin.com/company/invoratechnology-pvt-ltd/" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400">
              <FaLinkedin className="text-xl" />
            </a>
           
          </div>
        </div>

        {/* Links, Contact & Address */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 text-sm w-full">
          
          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-gray-400">
              <li><a href="/automotive" className="hover:text-white">Automotive</a></li>
              <li><a href="/switchyard" className="hover:text-white">Locomotive</a></li>
              <li><a href="/switchgear" className="hover:text-white">Panel Design</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <div className="space-y-3 text-gray-400">
              <div className="flex items-center space-x-2">
                <IoPhonePortraitOutline className="text-blue-400" />
                <a href="tel:+917477048415" className="hover:text-white">+91 7477048415</a>
              </div>
              <div className="flex items-center space-x-2">
                <MdMailOutline className="text-blue-400" />
                <a href="mailto:contact@invoratechnology.com" className="hover:text-white">
                  contact@invoratechnology.com
                </a>
              </div>
            </div>
          </div>

          {/* Address */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Address</h3>
            <div className="flex items-start space-x-2 text-gray-400">
              <MdOutlineLocationOn className="text-blue-400 text-xl" />
              <p>
                Sitabuldi<br />
                Nagpur, Maharashtra, <br />
                India 440012
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="mt-12 border-t border-gray-700 pt-4 text-center text-sm text-gray-500">
        &copy; {new Date().getFullYear()} iNVORA Technology | All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
